import React from "react";
import PropTypes from "prop-types";
import PageTemplate from "../../templates/PageTemplate";
import Menu from '../../organisms/Menu';

function MenuPage(props) {
    const {
        mealConstructorCollections
    } = props;
    return (
        <PageTemplate>
            <Menu
                mealConstructorCollections={mealConstructorCollections}
            />
        </PageTemplate>
    );
}

MenuPage.propTypes = {
    mealConstructorCollections: PropTypes.object
};

export default MenuPage;
